
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagService } from '@fp/services';

@Directive({
    selector: '[ifFeature]'
})
export class IfFeatureDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private featureToggleService: FeatureFlagService
    ) { }

    @Input()
    set ifFeature(featureKey: string) {
        this.featureToggleService.isFeatureEnabled(featureKey).then((isEnabled) => {
            if (isEnabled) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        });
    }
}